import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Card,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import { AssignmentReturned as AssignmentReturnedIcon } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import { TaskStatusLabel as TaskStatusLabelV2 } from '@sierralabs/workflow-ui';

import CardTitle from '../../../common/card/CardTitle';
import { useFindDocumentChangeOrdersV2 } from '../Document.hook';
import { FileDto } from '../Document.interface';

export interface DocumentChangeOrderV2ReferenceCardProps {
  document: FileDto;
  version?: number;
}

const DocumentChangeOrderV2ReferenceCard: React.FC<
  DocumentChangeOrderV2ReferenceCardProps
> = props => {
  const { document, version } = props;
  const history = useHistory();
  const { changeOrders, isLoading, error, findChangeOrders } =
    useFindDocumentChangeOrdersV2(document.id);

  useEffect(() => {
    findChangeOrders(version ? { version } : undefined);
  }, [version, findChangeOrders]);

  return (
    <Card>
      <CardTitle>
        <AssignmentReturnedIcon />
        Change Order (v2) References
      </CardTitle>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={3} padding='none'>
                  <LinearProgress />
                </TableCell>
              </TableRow>
            )}
            {error && (
              <TableRow>
                <TableCell colSpan={3} padding='none'>
                  <Alert severity='error'>{error.message}</Alert>
                </TableCell>
              </TableRow>
            )}

            {/* hide row if ChangeOrderV2 is not supported/implemented */}
            {error?.statusCode !== 501 &&
              (!changeOrders || changeOrders.length === 0) && (
                <TableRow>
                  <TableCell colSpan={3}>
                    {isLoading ? 'Loading...' : 'No linked Change Orders.'}
                  </TableCell>
                </TableRow>
              )}

            {changeOrders?.map((changeOrder, index) => (
              <TableRow
                hover={!!changeOrder.taskPath}
                key={`${changeOrder.id}-${index}`}
                onClick={() => {
                  changeOrder.taskPath && history.push(changeOrder.taskPath);
                }}
              >
                <TableCell>{changeOrder.taskV2.key}</TableCell>
                <TableCell>{changeOrder.name}</TableCell>
                <TableCell>
                  <TaskStatusLabelV2 task={changeOrder.taskV2} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

export default DocumentChangeOrderV2ReferenceCard;
